/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file PthIndicatorView.jsx
 * @author Fernando Ruano
 * @description PthIndicator View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

// Commons
import styleGuideColors from 'commons/styleGuideColors';

// Components
import DashboardProgress from 'components/Charts/DashboardProgress';
import { Spin } from 'antd';

/**
 * Pth Indicator View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function PthIndicatorView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);
  const [current, setCurrent] = useState(0);

  const { getPthIndicator } = dashboardStaffActions;

  const stageMenu = {
    label: translate('indicators.stage'),
    items: [
      { key: 0, value: '3' },
      { key: 1, value: '4' },
      { key: 2, value: '5' }
    ]
  };

  const getCurrentStage = () => {
    return stageMenu?.items[current].value;
  };

  const getProgressData = (key, color, total) => {
    return {
      label: translate(`commons.${key.clasificacion}`),
      value: ((key.cantidad * 100) / total).toFixed(3).slice(0, -1),
      color,
      cantidad: key.cantidad,
      classification: key.clasificacion
    };
  };

  const onGetData = (_, resp) => {
    if (resp?.data) {
      let data = {};
      let progress = {};
      let max = {};
      let total = 0;

      resp?.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      resp?.data?.forEach((itm) => {
        if (itm.clasificacion === 'Cumple') {
          progress = getProgressData(
            itm,
            styleGuideColors.baxterBrandTeal,
            total
          );
        } else {
          max = getProgressData(itm, styleGuideColors.alertError, total);
        }
      });
      data = {
        progress,
        max
      };
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  const getIndicatorInfo = (stage) => {
    setChartData(null);
    getPthIndicator({ clinicId, stage }, onGetData);
  };

  useEffect(() => {
    getIndicatorInfo(getCurrentStage());
  }, []);

  const handleDetailClick = (section) => {
    const { cantidad: totalItems, classification } = chartData[section];
    const stage = getCurrentStage();
    history.push(
      `/main/dashboard-detail/pth/${classification}/${stage}/${totalItems}`
    );
  };

  return chartData ? (
    <DashboardProgress
      title=" "
      isTitleBold={false}
      description=" "
      max={chartData.max}
      progress={chartData.progress}
      onDetailClick={handleDetailClick}
      selectMenu={{
        menu: stageMenu,
        onSelectItem: (item) => {
          setCurrent(item.key);
          getIndicatorInfo(stageMenu.items[item.key].value);
        },
        current: getCurrentStage()
      }}
    />
  ) : (
    <Spin />
  );
}

/**
 * Component definition of proptypes.
 */
PthIndicatorView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getPthIndicator: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default PthIndicatorView;
